var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8625 31.9827L32.3625 17.3994C31.6676 16.784 30.333 16.784 29.6381 17.3994L13.1381 31.9827C12.9006 32.1921 12.7447 32.4519 12.6894 32.7305C12.6341 33.0091 12.6817 33.2944 12.8265 33.5519C13.1198 34.0783 13.7761 34.4167 14.5003 34.4167H18.167V44.625C18.167 45.0118 18.3601 45.3827 18.7039 45.6562C19.0478 45.9297 19.5141 46.0833 20.0003 46.0833H25.5003C25.9865 46.0833 26.4528 45.9297 26.7967 45.6562C27.1405 45.3827 27.3336 45.0118 27.3336 44.625V38.7917H34.667V44.625C34.667 45.0118 34.8601 45.3827 35.2039 45.6562C35.5478 45.9297 36.0141 46.0833 36.5003 46.0833H42.0003C42.4865 46.0833 42.9528 45.9297 43.2967 45.6562C43.6405 45.3827 43.8336 45.0118 43.8336 44.625V34.4167H47.5003C47.8554 34.4179 48.2032 34.3369 48.5014 34.1835C48.7995 34.0302 49.0352 33.8112 49.1796 33.5532C49.324 33.2952 49.3709 33.0093 49.3146 32.7304C49.2583 32.4516 49.1012 32.1918 48.8625 31.9827Z",
    fill: "#05386B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.abce05f111f039324dca8b716dfdaa39.svg";
export { ForwardRef as ReactComponent };